<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper modal-full">
                <div class="modal-container" v-if="!loading">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <slot name="header"></slot>
                        </h5>
                        <button type="button" class="close" @click="$emit('close')">×</button>
                    </div>
                    <div class="modal-body">
                        <slot>
                            default body
                        </slot>
                    </div>
                </div>
                <div v-else>
                    <div style="margin-top:20px" class="loading-mask"></div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
let listener
let that
let handler = (evt) => {
    if (evt.keyCode === 27) {
        that.$emit('close')
    }
}
export default {
    props: {
        loading: false
    },
    destroyed() {
        document.removeEventListener('keyup', handler)
    },
    mounted() {
        that = this
        listener = document.addEventListener('keyup', handler)
    }
}
</script>
<style>
.modal-mask {
    position: absolute;
    z-index: 9998000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
    /*display: table;*/
    transition: opacity .3s ease;
    padding-top: 3%;
}
.modal-wrapper {
    /*display: table-cell;*/
    /*vertical-align: middle;*/
    /*top:50px;*/
    position: fixed;
    right: 0;
    left: 0;
    margin-right: auto;
    margin-left: auto;
    padding: 10px;
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    height: 80%;
}

@media only screen and (max-width: 1399px) {
    .modal-wrapper {
        width: 90%;
    }
}

@media only screen and (min-width: 1400px) {
    .modal-wrapper {
        width: 80%;
    }
}

@media only screen and (min-width: 1601px) {
    .modal-wrapper {
        width: 70%;
    }
}

.modal-container {
    overflow: scroll;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
    /*    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;*/
}

.modal-default-button {
    float: right;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/components/common/Modal.vue